export default IconListTree => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-list-tree" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M9 6h11" />
  <path d="M12 12h8" />
  <path d="M15 18h5" />
  <path d="M5 6v.01" />
  <path d="M8 12v.01" />
  <path d="M11 18v.01" />
</svg>`;